export var LOAD_CODE_START = 'LOAD_CODE_START';
export var LOAD_CODE_DONE = 'LOAD_CODE_DONE';
export var LOAD_CODE_FAILED = 'LOAD_CODE_FAILED';
export var SET_CURRENT_LANG = 'SET_CURRENT_LANG';
export var SET_DEFAULT_PROJECT_LANG = 'SET_DEFAULT_PROJECT_LANG';
